
import ReactGA from 'react-ga';
const property = process.env.REACT_APP_GA_PROPERTY || "";
const debug = process.env.REACT_APP_DEBUG;
ReactGA.initialize(property,
    { debug: !!debug, }
);
export default ReactGA;